import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HashLocationStrategy, LocationStrategy } from "@angular/common";

import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { DatepickerModule } from 'ngx-bootstrap/datepicker';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AlertModule } from 'ngx-bootstrap/alert';

import { SharedComponentModule } from '../../shared/shared.module';
import { SystemPaths } from '../../shared/system-paths';
import { AuthUtils } from '../../shared/authutils';
import { SystemUtils } from '../../shared/systemutils';
import { CookieUtils } from '../../shared/cookieutils';
import { AmericanFootballUtils } from '../../shared/usftbl-utils';
import { SharedScoreboardComponentModule } from '../shared.module';

import { BaseServiceExceptionHandler } from '../../service/base-service-exception-handler';
import { GetAccountByUsernameService } from '../../service/get-account-by-username.service';
import { GetLeagueByAbbrService } from '../../service/get-league-by-abbr.service';
import { GetSeasonsForLeagueService } from '../../service/get-seasons-for-league.service';
import { GetGameSummariesForSeasonService } from '../../service/get-game-summaries-for-season.service';
import { GetTeamSummariesForSeasonService } from '../../service/get-team-summaries-for-season.service';

import { AmericanFootballScheduleComponent } from './schedule-usftbl.component';
import { AmericanFootballScoreboardComponent } from './scoreboard-usftbl.component';

@NgModule({
  declarations: [
    AmericanFootballScheduleComponent,
    AmericanFootballScoreboardComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    TypeaheadModule.forRoot(),
    DatepickerModule.forRoot(),
    TabsModule.forRoot(),
    ButtonsModule.forRoot(),
    BsDropdownModule.forRoot(),
    AccordionModule.forRoot(),
    AlertModule.forRoot(),
    SharedComponentModule,
    SharedScoreboardComponentModule
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
	  SystemPaths,
    AuthUtils,
    SystemUtils,
    CookieUtils,
    AmericanFootballUtils,
    BaseServiceExceptionHandler,
    GetAccountByUsernameService,
    GetLeagueByAbbrService
  ],
  bootstrap: [AmericanFootballScheduleComponent]
})
export class AppModule { }
